import { createRouter } from "@tanstack/react-router";
import type { AuthContext } from "@/contexts/AuthContext";
import { routeTree } from "@/routeTree.gen";

export const router = createRouter({
  routeTree,
  context: {
    // Context is passed to RouterProvider in main.tsx,
    // which replaces the default context defined here.
    auth: {
      isAuthenticated: false,
      setIsAuthenticated: () => {
        throw new Error("setIsAuthenticated not implemented");
      },
    },
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface RouterContext {
    auth: AuthContext;
  }
}
